/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect, useMemo, createContext } from 'react'
import PropTypes from 'prop-types'
// import moment from 'moment'
// import { Manager } from 'socket.io-client'
import Toast from 'react-bootstrap/Toast'
import ToastContainer from 'react-bootstrap/ToastContainer'
// import ExcelJS from 'exceljs'
import apiServices from '../services/apiServices'

// const fields = {
//   Facebook: 'Meta',
//   report: '報表',
//   total: '總計',
//   level: '層級',
//   date: '時間',
//   delivery: '投遞',
//   action: '動作',
//   asset: '設定',
//   result: '成效',
//   interactive: '互動',
//   conversions: '轉換次數',
//   setting: '設定',
//   reach: '觸及人數',
//   frequency: '頻率',
//   impressions: '曝光次數',
//   delivery_info: '投遞狀態',
//   spend: '花費金額',
//   clicks: '點擊次數',
//   'relevance_score:score': '相關性分數',
//   cpc: 'CPC',
//   ctr: 'CTR',
//   quality_ranking: '品質排名',
//   engagement_rate_ranking: '互動率排名',
//   conversion_rate_ranking: '轉換率排名',
//   impressions_gross: '總曝光次數（包含非人為流量帶來的無效曝光次數）',
//   impressions_auto_refresh: '自動重新整理的曝光次數',
//   cost_per_result: '每次成果的成本',
//   cpp: '每觸及千人的成本',
//   cpm: 'CPM（每千次廣告曝光成本）',
//   ad_delivery: '廣告投遞',
//   adset_delivery: '廣告組合投遞',
//   campaign_delivery: '行銷活動投遞',
//   'actions:page_engagement': '粉絲專頁互動',
//   'actions:like': '粉絲專頁的讚',
//   'actions:comment': '貼文留言',
//   'actions:post_engagement': '貼文互動次數',
//   'actions:post_reaction': '貼文心情數',
//   'actions:onsite_conversion.post_save': '貼文儲存次數',
//   'actions:post': '貼文分享次數',
//   'actions:photo_view': '相片瀏覽次數',
//   'actions:rsvp': '活動回覆次數',
//   'actions:checkin': '打卡次數',
//   'cost_per_action_type:offsite_conversion.fb_pixel_purchase':
//     '每次網站購買成本',
//   'cost_per_action_type:page_engagement': '每次粉絲專頁互動成本',
//   'cost_per_action_type:like': '每次粉絲專頁按讚成本',
//   'cost_per_action_type:post_engagement': '每次貼文互動成本',
//   'cost_per_action_type:rsvp': '每次活動回覆成本',
//   'actions:onsite_conversion.messaging_first_reply': '新增為訊息聯繫對象的人數',
//   'actions:onsite_conversion.messaging_block': '封鎖的訊息聯繫對象',
//   'cost_per_action_type:onsite_conversion.messaging_first_reply':
//     '每位新訊息聯繫對象成本',
//   'unique_video_continuous_2_sec_watched_actions:video_view':
//     '影片連續播放 2 秒以上的不重複次數',
//   'video_continuous_2_sec_watched_actions:video_view':
//     '影片連續播放 2 秒以上的次數',
//   'actions:video_view': '影片播放 3 秒以上的次數',
//   'video_thruplay_watched_actions:video_view': 'ThruPlays',
//   'video_p25_watched_actions:video_view': '影片播放到 25% 的次數',
//   'video_p50_watched_actions:video_view': '影片播放到 50% 的次數',
//   'video_p75_watched_actions:video_view': '影片播放到 75% 的次數',
//   'video_p95_watched_actions:video_view': '影片播放到 95% 的次數',
//   'video_p100_watched_actions:video_view': '影片播放到 100% 的次數',
//   'video_avg_time_watched_actions:video_view': '影片平均播放時間',
//   'video_play_actions:video_view': '影片播放次數',
//   canvas_avg_view_time: '即時體驗觀看時間',
//   canvas_avg_view_percent: '即時體驗觀看百分比',
//   'cost_per_2_sec_continuous_video_view:video_view':
//     '每次影片連續播放 2 秒以上的成本',
//   'cost_per_action_type:video_view': '每次影片播放 3 秒以上的成本',
//   'cost_per_thruplay:video_view': '每次 ThruPlay 成本',
//   inline_link_clicks: '廣告中的內嵌連結點擊次數',
//   'actions:link_click': '連結點擊次數',
//   'unique_actions:link_click': '不重複連結點擊次數',
//   'outbound_clicks:outbound_click': '連外點擊次數',
//   'unique_outbound_clicks:outbound_click': '不重複連外點擊次數',
//   'website_ctr:link_click': 'CTR（連結點閱率)',
//   unique_link_clicks_ctr: '不重複點閱率（連結點閱率)',
//   'outbound_clicks_ctr:outbound_click': '連外 CTR（點擊率)',
//   'unique_outbound_clicks_ctr:outbound_click': '不重複連外 CTR（點閱率)',
//   unique_clicks: '不重複點擊次數（全部)',
//   unique_ctr: '不重複 CTR（全部)',
//   'cost_per_action_type:link_click': 'CPC（單次連結點擊成本）',
//   'cost_per_unique_action_type:link_click': '每次不重複連結點擊成本',
//   'cost_per_outbound_click:outbound_click': '單次連外點擊成本',
//   'cost_per_unique_outbound_click:outbound_click': '每次不重複連外點擊成本',
//   cost_per_unique_click: '單次不重複點擊成本（全部）',
//   estimated_ad_recallers: '廣告回想提升估計值（人數）',
//   estimated_ad_recall_rate: '廣告回想提升率估計值',
//   cost_per_estimated_ad_recallers: '每次廣告回想提升估計值成本（人數）',
//   'store_visit_actions:store_visit': '商店瀏覽次數',
//   'cost_per_store_visit_action:store_visit': '每次來店成本',
//   'actions:omni_view_content': '內容瀏覽次數',
//   'cost_per_action_type:omni_view_content': '每次內容瀏覽的成本',
//   'action_values:omni_view_content': '內容瀏覽轉換值',
//   'unique_actions:omni_view_content': '不重複內容瀏覽人數',
//   'cost_per_unique_action_type:omni_view_content':
//     '每個不重複內容瀏覽人數的成本',
//   'actions:offline_conversion.other': '其他轉換（離線）',
//   'cost_per_action_type:offline_conversion.other': '每次離線的其他轉換成本',
//   'action_values:offline_conversion.other': '離線的其他轉換值',
//   'actions:add_to_cart': '加到購物車次數',
//   'cost_per_action_type:add_to_cart': '每次加到購物車的成本',
//   'action_values:add_to_cart': '加到購物車的轉換值',
//   'unique_actions:add_to_cart': '不重複加到購物車人數',
//   'cost_per_unique_action_type:add_to_cart': '每次不重複加到購物車的成本',
//   'actions:add_to_wishlist': '加到願望清單次數',
//   'cost_per_action_type:add_to_wishlist': '每次加到願望清單的成本',
//   'action_values:add_to_wishlist': '加到願望清單轉換值',
//   'unique_actions:add_to_wishlist': '加到願望清單的不重複人數',
//   'cost_per_unique_action_type:add_to_wishlist':
//     '每位新增項目到願望清單的不重複用戶成本',
//   'actions:omni_activate_app': '應用程式啟用次數',
//   'cost_per_action_type:omni_activate_app': '每次應用程式啟用成本',
//   'action_values:omni_activate_app': '應用程式啟用轉換值',
//   'unique_actions:omni_activate_app': '不重複應用程式啟用次數',
//   'cost_per_unique_action_type:omni_activate_app': '每次不重複應用程式啟用成本',
//   'conversions:find_location_total': '地點搜尋次數',
//   'cost_per_conversion:find_location_total': '每次尋找分店地點的成本',
//   'conversion_values:find_location_total': '尋找分店地點轉換值',
//   'actions:onsite_conversion.flow_complete': '完成 Facebook 站內工作流程',
//   'cost_per_action_type:onsite_conversion.flow_complete':
//     '每次完成 Facebook 站內工作流程的成本',
//   'action_values:onsite_conversion.flow_complete':
//     '完成 Facebook 站內工作流程轉換值',
//   'actions:omni_tutorial_completion': '完成教學導覽',
//   'cost_per_action_type:omni_tutorial_completion': '每次完成教學導覽的成本',
//   'action_values:omni_tutorial_completion': '完成教學導覽轉換值',
//   'unique_actions:omni_tutorial_completion': '不重複完成教學導覽人數',
//   'cost_per_unique_action_type:omni_tutorial_completion':
//     '每次完成不重複教學導覽的成本',
//   'actions:omni_complete_registration': '完成註冊次數',
//   'cost_per_action_type:omni_complete_registration': '每次完成註冊的成本',
//   'action_values:omni_complete_registration': '完成註冊轉換值',
//   'unique_actions:omni_complete_registration': '不重複完成註冊人數',
//   'cost_per_unique_action_type:omni_complete_registration':
//     '每個不重複完成註冊人數的成本',
//   'actions:omni_rate': '已提交評分',
//   'cost_per_action_type:omni_rate': '每次提交評分的成本',
//   'action_values:omni_rate': '提交評分轉換值',
//   'unique_actions:omni_rate': '不重複提交評分人數',
//   'cost_per_unique_action_type:omni_rate': '每次提交不重複評分的成本',
//   'actions:omni_spend_credits': 'FB 幣支出',
//   'cost_per_action_type:omni_spend_credits': '每次 FB 幣支付成本',
//   'action_values:omni_spend_credits': 'FB 幣支出轉換總值',
//   'unique_actions:omni_spend_credits': '不重複 FB 幣支出人數',
//   'cost_per_unique_action_type:omni_spend_credits': '每次不重複 FB 幣支付成本',
//   'conversions:ad_impression_mobile_app': '應用程式內廣告曝光次數',
//   'cost_per_conversion:ad_impression_mobile_app':
//     '每千次應用程式內廣告曝光成本',
//   'conversions:ad_click_mobile_app': '應用程式內廣告點擊次數',
//   'cost_per_conversion:ad_click_mobile_app': '每次應用程式內廣告點擊成本',
//   'actions:omni_app_install': '應用程式安裝次數',
//   'cost_per_action_type:omni_app_install': '每次應用程式安裝成本',
//   'actions:omni_achievement_unlocked': '成就解鎖次數',
//   'cost_per_action_type:omni_achievement_unlocked': '每次成就解鎖成本',
//   'action_values:omni_achievement_unlocked': '成就解鎖轉換值',
//   'unique_actions:omni_achievement_unlocked': '不重複成就解鎖人數',
//   'cost_per_unique_action_type:omni_achievement_unlocked':
//     '每個不重複成就解鎖人數的成本',
//   'conversions:donate_total': '捐款',
//   'cost_per_conversion:donate_total': '每次捐款的成本',
//   'conversion_values:donate_total': '捐款轉換值',
//   'actions:omni_search': '搜尋',
//   'cost_per_action_type:omni_search': '每次搜尋的成本',
//   'action_values:omni_search': '搜尋轉換值',
//   'unique_actions:omni_search': '不重複搜尋次數',
//   'cost_per_unique_action_type:omni_search': '每次不重複搜尋次數的成本',
//   'actions:add_payment_info': '新增付款資料次數',
//   'cost_per_action_type:add_payment_info': '每次新增付款資料的成本',
//   'action_values:add_payment_info': '新增付款資料的轉換值',
//   'unique_actions:add_payment_info': '不重複新增付款資料人數',
//   'cost_per_unique_action_type:add_payment_info':
//     '每次不重複新增付款資料的成本',
//   'actions:app_engagement': '桌面版應用程式互動次數',
//   'cost_per_action_type:app_engagement': '每次桌面版應用程式互動成本',
//   'actions:app_use': '桌面版應用程式使用次數',
//   'cost_per_action_type:app_use': '每次桌面版應用程式使用成本',
//   'actions:app_story': '桌面版應用程式動態互動次數',
//   'cost_per_action_type:app_story': '每次桌面版應用程式動態互動成本',
//   'actions:lead': '潛在顧客',
//   'cost_per_action_type:lead': '每位潛在顧客取得成本',
//   'action_values:lead': '潛在顧客轉換值',
//   'actions:games.plays': '玩遊戲次數',
//   'cost_per_action_type:games.plays': '每次玩遊戲成本',
//   'conversions:submit_application_total': '申請表提交次數',
//   'cost_per_conversion:submit_application_total': '每次申請表提交的成本',
//   'conversion_values:submit_application_total': '提交申請表轉換值',
//   'actions:omni_level_achieved': '破關',
//   'cost_per_action_type:omni_level_achieved': '每次破關成本',
//   'action_values:omni_level_achieved': '破關轉換值',
//   'unique_actions:omni_level_achieved': '不重複破關人數',
//   'cost_per_unique_action_type:omni_level_achieved': '每個不重複破關人數的成本',
//   'conversions:contact_total': '聯絡',
//   'cost_per_conversion:contact_total': '每次聯絡成本',
//   'conversion_values:contact_total': '聯絡轉換值',
//   'actions:omni_custom': '自訂事件',
//   'cost_per_action_type:omni_custom': '每次自訂事件成本',
//   'conversions:customize_product_total': '自訂產品次數',
//   'cost_per_conversion:customize_product_total': '每次自訂產品的成本',
//   'conversion_values:customize_product_total': '自訂產品轉換值',
//   'actions:app_custom_event.fb_mobile_d2_retention':
//     '行動應用程式第 2 天留存率',
//   'cost_per_action_type:app_custom_event.fb_mobile_d2_retention':
//     '每次行動應用程式第 2 天留存成本',
//   'unique_actions:app_custom_event.fb_mobile_d2_retention':
//     '不重複行動應用程式第 2 天留存率',
//   'cost_per_unique_action_type:app_custom_event.fb_mobile_d2_retention':
//     '每次行動應用程式第 2 天不重複留存成本',
//   'actions:app_custom_event.fb_mobile_d7_retention':
//     '行動應用程式第 7 天留存率',
//   'cost_per_action_type:app_custom_event.fb_mobile_d7_retention':
//     '行動應用程式第 7 天留存率',
//   'unique_actions:app_custom_event.fb_mobile_d7_retention':
//     '不重複行動應用程式第 7 天留存率',
//   'cost_per_unique_action_type:app_custom_event.fb_mobile_d7_retention':
//     '每次行動應用程式第 7 天不重複留存成本',
//   'conversions:subscribe_total': '訂閱',
//   'cost_per_conversion:subscribe_total': '每次訂閱成本',
//   'conversion_values:subscribe_total': '訂閱轉換值',
//   'actions:omni_purchase': '購買內容',
//   'cost_per_action_type:omni_purchase': '每次購買的成本',
//   'action_values:omni_purchase': '購買轉換值',
//   'unique_actions:omni_purchase': '不重複購買人數',
//   'cost_per_unique_action_type:omni_purchase': '每次不重複購買的成本',
//   'purchase_roas:omni_purchase': '購買 ROAS（廣告投資報酬率）',
//   'actions:landing_page_view': '連結頁面瀏覽次數',
//   'cost_per_action_type:landing_page_view': '每次連結頁面瀏覽成本',
//   'unique_actions:landing_page_view': '不重複連結頁面瀏覽次數',
//   'cost_per_unique_action_type:landing_page_view': '每次不重複連結頁面瀏覽成本',
//   'actions:omni_initiated_checkout': '開始結帳',
//   'cost_per_action_type:omni_initiated_checkout': '每次開始結帳的成本',
//   'action_values:omni_initiated_checkout': '開始結帳轉換值',
//   'unique_actions:omni_initiated_checkout': '不重複開始結帳人數',
//   'cost_per_unique_action_type:omni_initiated_checkout':
//     '每次不重複開始結帳的成本',
//   'conversions:start_trial_total': '開始試用',
//   'cost_per_conversion:start_trial_total': '每次開始試用的成本',
//   'conversion_values:start_trial_total': '開始試用轉換值',
//   'conversions:schedule_total': '預約安排次數',
//   'cost_per_conversion:schedule_total': '每次排程的成本',
//   'conversion_values:schedule_total': '排程轉換值',
//   'actions:app_custom_event.fb_mobile_content_view': '內容瀏覽（行動應用程式）',
//   'actions:offsite_conversion.fb_pixel_view_content': '網站內容瀏覽',
//   'actions:offline_conversion.view_content': '內容瀏覽次數（離線）',
//   'actions:onsite_conversion.view_content': '在 Facebook 上瀏覽內容',
//   'action_values:app_custom_event.fb_mobile_content_view':
//     '內容瀏覽（行動應用程式）轉換值',
//   'action_values:offsite_conversion.fb_pixel_view_content':
//     '內容瀏覽次數轉換值（網站）',
//   'action_values:offline_conversion.view_content': '內容瀏覽次數轉換值（離線）',
//   'action_values:onsite_conversion.view_content':
//     '在Facebook上瀏覽內容的轉換值',
//   'unique_actions:app_custom_event.fb_mobile_content_view':
//     '不重複內容瀏覽（行動應用程式）',
//   'actions:app_custom_event.fb_mobile_add_to_cart':
//     '行動應用程式購物車新增項目次數',
//   'actions:offline_conversion.add_to_cart': '網站加到購物車',
//   'actions:onsite_conversion.add_to_cart': '離線加到購物車',
//   'actions:offsite_conversion.fb_pixel_add_to_cart': '在 Facebook 加到購物車',
//   'action_values:app_custom_event.fb_mobile_add_to_cart':
//     '加到購物車（行動應用程式）的轉換值',
//   'action_values:offsite_conversion.fb_pixel_add_to_cart':
//     '加到購物車（網站）的轉換值',
//   'action_values:offline_conversion.add_to_cart': '加到購物車（離線）的轉換值',
//   'action_values:onsite_conversion.add_to_cart': '在Facebook加到購物車的轉換值',
//   'unique_actions:app_custom_event.fb_mobile_add_to_cart':
//     '不重複行動應用程式購物車新增項目次數',
//   'actions:app_custom_event.fb_mobile_add_to_wishlist':
//     '行動應用程式加到願望清單次數',
//   'actions:offsite_conversion.fb_pixel_add_to_wishlist': '網站加到願望清單',
//   'actions:offline_conversion.add_to_wishlist': '離線加到願望清單',
//   'action_values:app_custom_event.fb_mobile_add_to_wishlist':
//     '行動應用程式加到願望清單的轉換值',
//   'action_values:offsite_conversion.fb_pixel_add_to_wishlist':
//     '網站加到願望清單的轉換值',
//   'action_values:offline_conversion.add_to_wishlist':
//     '離線加到願望清單的轉換值',
//   'unique_actions:app_custom_event.fb_mobile_add_to_wishlist':
//     '新增項目到願望清單的不重複人數（行動應用程式）',
//   'actions:app_custom_event.fb_mobile_activate_app': '行動應用程式連線階段',
//   'action_values:app_custom_event.fb_mobile_activate_app':
//     '連線階段轉換值（行動應用程式）',
//   'unique_actions:app_custom_event.fb_mobile_activate_app':
//     '不重複連線階段（行動應用程式）',
//   'conversions:find_location_mobile_app': '行動應用程式地點搜尋次數 ',
//   'conversions:find_location_website': '地點搜尋（網站）',
//   'conversions:find_location_offline': '離線地點搜尋次數 ',
//   'conversion_values:find_location_mobile_app':
//     '行動應用程式尋找分店地點轉換值',
//   'conversion_values:find_location_website': '網站尋找分店地點轉換值',
//   'conversion_values:find_location_offline': '離線尋找分店地點轉換值',
//   'actions:app_custom_event.fb_mobile_tutorial_completion':
//     '完成行動應用程式教學導覽',
//   'action_values:app_custom_event.fb_mobile_tutorial_completion':
//     '完成行動應用程式教學導覽的轉換值',
//   'unique_actions:app_custom_event.fb_mobile_tutorial_completion':
//     '完成不重複的行動應用程式教學導覽',
//   'actions:app_custom_event.fb_mobile_complete_registration':
//     '完成行動應用程式註冊作業',
//   'actions:offsite_conversion.fb_pixel_complete_registration':
//     '完成註冊（網站）',
//   'actions:offline_conversion.complete_registration': '完成註冊（離線）',
//   'action_values:app_custom_event.fb_mobile_complete_registration':
//     '完成行動應用程式註冊作業的轉換值',
//   'action_values:offsite_conversion.fb_pixel_complete_registration':
//     '完成註冊轉換值（網站)',
//   'action_values:offline_conversion.complete_registration':
//     '完成註冊轉換值（離線）',
//   'unique_actions:app_custom_event.fb_mobile_complete_registration':
//     '不重複的行動應用程式註冊次數',
//   'actions:app_custom_event.fb_mobile_rate': '提交評分（行動應用程式）',
//   'action_values:app_custom_event.fb_mobile_rate':
//     '提交評分（行動應用程式）的轉換值',
//   'unique_actions:app_custom_event.fb_mobile_rate':
//     '不重複評比提交人數（行動應用程式）',
//   'actions:app_custom_event.fb_mobile_spent_credits':
//     'FB 幣支出（行動應用程式）',
//   'actions:credit_spent': '桌面版應用程式 FB 幣支付',
//   'action_values:app_custom_event.fb_mobile_spent_credits':
//     '行動應用程式 FB 幣支出的轉換值',
//   'action_values:credit_spent': '桌面版 FB 幣支付轉換值',
//   'cost_per_unique_action_type:app_custom_event.fb_mobile_spent_credits':
//     '每次行動應用程式 FB 幣不重複支出的成本',
//   'unique_actions:app_custom_event.fb_mobile_spent_credits':
//     '不重複 FB 幣支出（行動應用程式）',
//   'actions:mobile_app_install': '行動應用程式安裝次數',
//   'actions:app_install': '桌面版應用程式安裝次數',
//   'actions:app_custom_event.fb_mobile_achievement_unlocked':
//     '成就解鎖（行動應用程式）',
//   'action_values:app_custom_event.fb_mobile_achievement_unlocked':
//     '成就解鎖轉換值（行動應用程式）',
//   'unique_actions:app_custom_event.fb_mobile_achievement_unlocked':
//     '不重複成就解鎖次數（行動應用程式）',
//   'conversions:donate_mobile_app': '行動應用程式捐款次數',
//   'conversions:donate_website': '網站捐款次數',
//   'conversions:donate_offline': '離線捐款',
//   'conversion_values:donate_mobile_app': '行動應用程式捐款轉換值',
//   'conversion_values:donate_website': '網站捐款轉換值',
//   'conversion_values:donate_offline': '離線捐款轉換值',
//   'actions:app_custom_event.fb_mobile_search': '行動應用程式搜尋',
//   'actions:offsite_conversion.fb_pixel_search': '網站搜尋',
//   'actions:offline_conversion.search': '離線搜尋',
//   'action_values:app_custom_event.fb_mobile_search': '行動應用程式搜尋轉換值',
//   'action_values:offsite_conversion.fb_pixel_search': '網站搜尋的轉換值',
//   'action_values:offline_conversion.search': '離線搜尋轉換值',
//   'unique_actions:app_custom_event.fb_mobile_search': '不重複行動應用程式搜尋',
//   'actions:app_custom_event.fb_mobile_add_payment_info':
//     '新增付款資料（行動應用程式）',
//   'actions:offsite_conversion.fb_pixel_add_payment_info': '網站新增付款資料',
//   'actions:offline_conversion.add_payment_info': '離線新增付款資料',
//   'action_values:app_custom_event.fb_mobile_add_payment_info':
//     '新增付款資料轉換值（行動應用程式）',
//   'action_values:offsite_conversion.fb_pixel_add_payment_info':
//     '網站新增付款資料的轉換值',
//   'action_values:offline_conversion.add_payment_info':
//     '離線新增付款資料的轉換值',
//   'unique_actions:app_custom_event.fb_mobile_add_payment_info':
//     '不重複新增付款資料次數（行動應用程式）',
//   'actions:onsite_conversion.lead_grouped': 'Facebook 站內潛在顧客',
//   'actions:offsite_conversion.fb_pixel_lead': '網站潛在顧客',
//   'actions:offline_conversion.lead': '離線潛在顧客',
//   'action_values:offsite_conversion.fb_pixel_lead': '網站潛在顧客轉換值',
//   'action_values:offline_conversion.lead': '離線潛在顧客的轉換值',
//   'action_values:onsite_conversion.lead_grouped': 'Facebook 站內潛在顧客轉換值',
//   'conversions:submit_application_mobile_app': '行動應用程式申請表提交次數',
//   'conversions:submit_application_website': '網站申請表提交次數',
//   'conversions:submit_application_offline': '離線申請表提交次數',
//   'conversion_values:submit_application_mobile_app':
//     '行動應用程式提交申請表轉換值',
//   'conversion_values:submit_application_website': '網站提交申請表轉換值',
//   'conversion_values:submit_application_offline': '離線提交申請表轉換值',
//   'actions:app_custom_event.fb_mobile_level_achieved': '破關（行動應用程式）',
//   'action_values:app_custom_event.fb_mobile_level_achieved':
//     '破關轉換值（行動應用程式）',
//   'unique_actions:app_custom_event.fb_mobile_level_achieved':
//     '不重複的破關次數（行動應用程式',
//   'conversions:contact_mobile_app': '行動應用程式聯絡次數',
//   'conversions:contact_website': '網站聯絡次數',
//   'conversions:contact_offline': '離線聯絡次數',
//   'conversion_values:contact_mobile_app': '行動應用程式聯絡轉換值',
//   'conversion_values:contact_website': '網站聯絡轉換值',
//   'conversion_values:contact_offline': '離線聯絡轉換值',
//   'actions:app_custom_event.other': '行動應用程式自訂事件',
//   'conversions:customize_product_mobile_app': '行動應用程式自訂產品次數',
//   'conversions:customize_product_website': '網站自訂產品次數',
//   'conversions:customize_product_offline': '離線自訂產品次數',
//   'conversion_values:customize_product_mobile_app':
//     '行動應用程式自訂產品轉換值',
//   'conversion_values:customize_product_website': '網站自訂產品轉換值',
//   'conversion_values:customize_product_offline': '離線自訂產品轉換值',
//   'conversions:subscribe_mobile_app': '行動應用程式訂閱次數',
//   'conversions:subscribe_website': '網站訂閱次數',
//   'conversions:subscribe_offline': '離線訂閱次數',
//   'conversion_values:subscribe_mobile_app': '行動應用程式訂閱轉換值',
//   'conversion_values:subscribe_website': '網站訂閱轉換值',
//   'conversion_values:subscribe_offline': '離線訂閱轉換值',
//   'actions:app_custom_event.fb_mobile_purchase': '行動應用程式購買',
//   'actions:offsite_conversion.fb_pixel_purchase': '網站購物',
//   'actions:offline_conversion.purchase': '離線購買',
//   'actions:onsite_conversion.purchase': 'Facebook 站內購買',
//   'action_values:app_custom_event.fb_mobile_purchase': '行動應用程式購買轉換值',
//   'action_values:offsite_conversion.fb_pixel_purchase': '網站購買的轉換值',
//   'action_values:offline_conversion.purchase': '離線購買轉換值',
//   'action_values:onsite_conversion.purchase': 'Facebook 站內購買轉換值',
//   'unique_actions:app_custom_event.fb_mobile_purchase':
//     '不重複行動應用程式購買',
//   'website_purchase_roas:offsite_conversion.fb_pixel_purchase':
//     '網站購買 ROAS（廣告投資報酬率）',
//   'mobile_app_purchase_roas:app_custom_event.fb_mobile_purchase':
//     '行動應用程式購買 ROAS（廣告投資報酬率）',
//   'actions:app_custom_event.fb_mobile_initiated_checkout':
//     '開始結帳（行動應用程式）',
//   'actions:offsite_conversion.fb_pixel_initiate_checkout': '開始結帳（網站）',
//   'actions:offline_conversion.initiate_checkout': '開始結帳（離線）',
//   'action_values:app_custom_event.fb_mobile_initiated_checkout':
//     '開始結帳轉換值（行動應用程式）',
//   'action_values:offsite_conversion.fb_pixel_initiate_checkout':
//     '開始結帳轉換值（網站）',
//   'action_values:offline_conversion.initiate_checkout':
//     '開始結帳轉換值（離線）',
//   'unique_actions:app_custom_event.fb_mobile_initiated_checkout':
//     '不重複開始結帳人數（行動應用程式）',
//   'conversions:start_trial_mobile_app': '行動應用程式開始試用次數',
//   'conversions:start_trial_website': '開始試用次數（網站）',
//   'conversions:start_trial_offline': '離線開始試用次數',
//   'conversion_values:start_trial_mobile_app': '行動應用程式開始試用轉換值',
//   'conversion_values:start_trial_website': '網站開始試用轉換值',
//   'conversion_values:start_trial_offline': '離線開始試用轉換值',
//   'conversions:schedule_mobile_app': '行動應用程式預約安排次數',
//   'conversions:schedule_website': '網站預約安排次數',
//   'conversions:schedule_offline': '離線預約安排次數',
//   'conversion_values:schedule_mobile_app': '行動應用程式排程轉換值',
//   'conversion_values:schedule_website': '網站排程轉換值',
//   'conversion_values:schedule_offline': '離線排程轉換值',
//   'catalog_segment_value:app_custom_event.fb_mobile_purchase': '',
//   'catalog_segment_value_website_purchase_roas:offsite_conversion.fb_pixel_purchase':
//     '',
//   'catalog_segment_value:offsite_conversion.fb_pixel_purchase': '',
//   'catalog_segment_value_mobile_purchase_roas:app_custom_event.fb_mobile_purchase':
//     '',
//   account_id: '帳號編號',
//   account_name: '帳號名稱',
//   date_start: '分析報告開始',
//   'segments.date': '日期',
//   date_stop: '分析報告結束',
//   adset_bid_value: '出價',
//   buying_type: '購買類型',
//   objective: '目標',
//   delivery_start: '排程',
//   name: '名稱',
//   ad_name: '廣告名稱',
//   ad_id: '廣告編號',
//   adset_budget_value: '廣告組合預算',
//   adset_id: '廣告組合編號',
//   adset_name: '廣告組合名稱',
//   campaign_budget_value: '行銷活動預算',
//   campaign_id: '行銷活動編號',
//   campaign_name: '行銷活動名稱',
//   body: '內文（廣告設定）',
//   preview_link: '預覽連結',
//   link_url: '連結（廣告設定）',
//   account_currency: '幣別',
//   account_timezone: '時區',
//   day_1: '日期',
//   day_7: '週數',
//   day_14: '2 週',
//   monthly: '月分',
//   age: '年齡',
//   gender: '性別',
//   place_page_id: '分店地點',
//   country: '國家',
//   region: '地區',
//   device: '裝置',
//   platform: '平台',
//   dma: 'DMA 地區',
//   impression_device: '瀏覽裝置',
//   publisher_platform: '平台',
//   platform_position: '版位',
//   device_platform: '裝置平台',
//   product_id: '產品編號',
//   hourly_stats_aggregated_by_advertiser_time_zone: '投遞時間（廣告帳號時區）',
//   hourly_stats_aggregated_by_audience_time_zone: '投遞時間（廣告受眾時區）',
//   action_device: '發生轉換的裝置',
//   action_reaction: '貼文心情類型',
//   action_destination: '目的地',
//   action_video_type: '影片觀看類型',
//   action_video_sound: '影片音效',
//   action_carousel_card_name: '輪播圖卡',
//   action_canvas_component_name: '即時體驗元件',
//   call_to_action_asset: '行動呼籲',
//   description_asset: '說明',
//   title_asset: '標題（廣告設定）',
//   image_asset: '圖像',
//   body_asset: '內文',
//   video_asset: '影片',
//   link_url_asset: '網站網址',
//   performance: '成效',
//   attributes: '屬性',
//   competitive_metrics: '競爭指標',
//   google_analytics: 'Google Analytics (分析)',
//   shopping_attributes: '購物屬性',
//   Combined_ad_and_organic_stats: '合併廣告和隨機統計資料',
//   'metrics.clicks': '點擊',
//   'metrics.impressions': '曝光',
//   'metrics.cost_micros': '費用',
//   'metrics.ctr': '點閱率',
//   'metrics.absolute_top_impression_percentage': '曝光 (絕對頂端) 百分比',
//   'metrics.top_impression_percentage': '曝光 (頂端) 百分比',
//   'metrics.average_cpc': '平均單次點擊出價',
//   'metrics.average_cpm': '平均千次曝光出價',
//   'metrics.invalid_clicks': '無效點擊',
//   'metrics.invalid_click_rate': '無效點擊率',
//   'metrics.phone_impressions': '電話曝光',
//   'metrics.phone_calls': '來電',
//   'metrics.phone_through_rate': '電話接通率',
//   'metrics.average_cpe': '平均單次參與出價',
//   'metrics.average_cpv': '平均單次收視出價',
//   'metrics.interactions': '互動',
//   'metrics.interaction_rate': '互動率',
//   'metrics.average_cost': '平均費用',
//   'metrics.video_views': '觀看次數',
//   'metrics.video_view_rate': '收視率',
//   'metrics.engagements': '參與',
//   'metrics.engagement_rate': '參與度',
//   'metrics.video_quartile_25_rate': '影片播放進度：25%',
//   'metrics.video_quartile_50_rate': '影片播放進度：50%',
//   'metrics.video_quartile_75_rate': '影片播放進度：75%',
//   'metrics.video_quartile_100_rate': '影片播放進度：100%',
//   'metrics.active_view_impressions': '可見曝光',
//   'metrics.active_view_measurable_impressions': '可評估的曝光',
//   'metrics.active_view_measurable_cost_micros': '可評估費用',
//   'metrics.active_view_measurability': '可評估率',
//   'metrics.active_view_viewability': '可見率',
//   'metrics.gmail_saves': 'Gmail 儲存',
//   'metrics.gmail_forwards': 'Gmail 轉寄',
//   'metrics.gmail_secondary_clicks': 'Gmail 點進網站',
//   'metrics.conversions': '轉換',
//   'metrics.cost_per_conversion': '單次轉換費用',
//   'metrics.conversions_from_interactions_rate': '轉換率',
//   'metrics.view_through_conversions': '瀏覽後轉換',
//   'metrics.all_conversions': '所有轉換',
//   'metrics.all_conversions_from_interactions_rate': '所有轉換率',
//   'metrics.cost_per_all_conversions': '費用/所有轉換',
//   'metrics.all_conversions_value': '所有轉換價值',
//   'metrics.all_conversions_value_per_cost': '所有轉換價值/費用',
//   'metrics.value_per_all_conversions': '價值/所有轉換',
//   'metrics.cross_device_conversions': '跨裝置轉換',
//   'metrics.conversions_value': '轉換價值',
//   'metrics.conversions_value_per_cost': '轉換價值/費用',
//   'metrics.value_per_conversion': '單次轉換價值',
//   'metrics.cost_per_current_model_attributed_conversion':
//     '單次轉換費用（目前模式）',
//   'metrics.current_model_attributed_conversions_from_interactions_rate':
//     '轉換率（目前模式）',
//   'metrics.current_model_attributed_conversions': '轉換（目前模式）',
//   'metrics.current_model_attributed_conversions_value': '轉換價值（目前模式）',
//   'metrics.current_model_attributed_conversions_value_per_cost':
//     '轉換價值/費用（目前模式）',
//   'metrics.value_per_current_model_attributed_conversion':
//     '單次轉換價值（目前模式）',
//   'metrics.search_impression_share': '曝光比重',
//   'metrics.search_absolute_top_impression_share':
//     '搜尋聯播網：絕對頂端曝光比重',
//   'metrics.search_top_impression_share': '搜尋聯播網：頂端曝光比重',
//   'metrics.search_click_share': '點擊比重',
//   'metrics.search_exact_match_impression_share': '搜尋聯播網：完全比對曝光比重',
//   'metrics.search_rank_lost_impression_share':
//     '搜尋聯播網：錯失的曝光比重 (排名)',
//   'metrics.search_budget_lost_impression_share':
//     '搜尋聯播網：錯失的曝光比重 (預算)',
//   'metrics.search_rank_lost_absolute_top_impression_share':
//     '搜尋聯播網：錯失的絕對頂端曝光比重 (排名)',
//   'metrics.search_budget_lost_absolute_top_impression_share':
//     '搜尋聯播網：錯失的絕對頂端曝光比重 (預算)',
//   'metrics.search_rank_lost_top_impression_share':
//     '搜尋聯播網：錯失的頂端曝光比重 (排名)',
//   'metrics.search_budget_lost_top_impression_share':
//     '搜尋聯播網：錯失的頂端曝光比重 (預算)',
//   'metrics.content_impression_share': '多媒體廣告聯播網：曝光比重',
//   'metrics.content_rank_lost_impression_share':
//     '多媒體廣告聯播網：錯失的曝光比重 (排名)',
//   'metrics.content_budget_lost_impression_share':
//     '多媒體廣告聯播網：錯失的曝光比重 (預算)',
//   'metrics.relative_ctr': '相對點閱率',
//   'metrics.bounce_rate': '跳出率',
//   'metrics.average_page_views': '平均工作階段頁數',
//   'metrics.average_time_on_site':
//     '平均工作階段時間長度 (秒): 這一欄與目前日期範圍不相容',
//   'metrics.percent_new_visitors': '新工作階段百分比',
//   cost_micros: '費用',
//   absolute_top_impression_percentage: '曝光 (絕對頂端) 百分比',
//   top_impression_percentage: '曝光 (頂端) 百分比',
//   average_cpc: '平均單次點擊出價',
//   average_cpm: '平均千次曝光出價',
//   invalid_clicks: '無效點擊',
//   invalid_click_rate: '無效點擊率',
//   phone_impressions: '電話曝光',
//   phone_calls: '來電',
//   phone_through_rate: '電話接通率',
//   average_cpe: '平均單次參與出價',
//   average_cpv: '平均單次收視出價',
//   interactions: '互動',
//   interaction_rate: '互動率',
//   average_cost: '平均費用',
//   video_views: '觀看次數',
//   video_view_rate: '收視率',
//   engagements: '參與',
//   engagement_rate: '參與度',
//   video_quartile_25_rate: '影片播放進度：25%',
//   video_quartile_50_rate: '影片播放進度：50%',
//   video_quartile_75_rate: '影片播放進度：75%',
//   video_quartile_100_rate: '影片播放進度：100%',
//   active_view_impressions: '可見曝光',
//   active_view_measurable_impressions: '可評估的曝光',
//   active_view_measurable_cost_micros: '可評估費用',
//   active_view_measurability: '可評估率',
//   active_view_viewability: '可見率',
//   gmail_saves: 'Gmail 儲存',
//   gmail_forwards: 'Gmail 轉寄',
//   gmail_secondary_clicks: 'Gmail 點進網站',
//   cost_per_conversion: '單次轉換費用',
//   conversions_from_interactions_rate: '轉換率',
//   view_through_conversions: '瀏覽後轉換',
//   all_conversions: '所有轉換',
//   all_conversions_from_interactions_rate: '所有轉換率',
//   cost_per_all_conversions: '費用/所有轉換',
//   all_conversions_value: '所有轉換價值',
//   all_conversions_value_per_cost: '所有轉換價值/費用',
//   value_per_all_conversions: '價值/所有轉換',
//   cross_device_conversions: '跨裝置轉換',
//   conversions_value: '轉換價值',
//   conversions_value_per_cost: '轉換價值/費用',
//   value_per_conversion: '單次轉換價值',
//   cost_per_current_model_attributed_conversion: '單次轉換費用（目前模式）',
//   current_model_attributed_conversions_from_interactions_rate:
//     '轉換率（目前模式）',
//   current_model_attributed_conversions: '轉換（目前模式）',
//   current_model_attributed_conversions_value: '轉換價值（目前模式）',
//   current_model_attributed_conversions_value_per_cost:
//     '轉換價值/費用（目前模式）',
//   value_per_current_model_attributed_conversion: '單次轉換價值（目前模式）',
//   search_impression_share: '曝光比重',
//   search_absolute_top_impression_share: '搜尋聯播網：絕對頂端曝光比重',
//   search_top_impression_share: '搜尋聯播網：頂端曝光比重',
//   search_click_share: '點擊比重',
//   search_exact_match_impression_share: '搜尋聯播網：完全比對曝光比重',
//   search_rank_lost_impression_share: '搜尋聯播網：錯失的曝光比重 (排名)',
//   search_budget_lost_impression_share: '搜尋聯播網：錯失的曝光比重 (預算)',
//   search_rank_lost_absolute_top_impression_share:
//     '搜尋聯播網：錯失的絕對頂端曝光比重 (排名)',
//   search_budget_lost_absolute_top_impression_share:
//     '搜尋聯播網：錯失的絕對頂端曝光比重 (預算)',
//   search_rank_lost_top_impression_share:
//     '搜尋聯播網：錯失的頂端曝光比重 (排名)',
//   search_budget_lost_top_impression_share:
//     '搜尋聯播網：錯失的頂端曝光比重 (預算)',
//   content_impression_share: '多媒體廣告聯播網：曝光比重',
//   content_rank_lost_impression_share: '多媒體廣告聯播網：錯失的曝光比重 (排名)',
//   content_budget_lost_impression_share:
//     '多媒體廣告聯播網：錯失的曝光比重 (預算)',
//   relative_ctr: '相對點閱率',
//   bounce_rate: '跳出率',
//   average_page_views: '平均工作階段頁數',
//   average_time_on_site: '平均工作階段時間長度 (秒): 這一欄與目前日期範圍不相容',
//   percent_new_visitors: '新工作階段百分比',
//   level_of_detail: '詳細程度',
//   targeting: '指定目標',
//   location: '地區',
//   time: '時間',
//   quality_score: '品質分數',
//   bid_simulator: '出價模擬工具',
//   Campaign: '廣告活動',
//   'Campaign ID': '廣告活動 ID',
//   'Ad group': '廣告群組',
//   'Ad group ID': '廣告群組 ID',
//   Ad: '廣告',
//   'Ad ID': '廣告 ID',
//   'Search keyword': '搜尋關鍵字',
//   'Keyword ID': '關鍵字 ID',
//   'Landing page': '到達網頁',
//   'Expanded landing page': '已展開的到達網頁',
//   'Click type': '點擊類型',
//   'Top vs. side': '頂端或側邊',
//   'Network (with search partners)': '聯播網 (及搜尋夥伴)',
//   Device: '裝置',
//   'Search term': '搜尋字詞',
//   Topic: '主題',
//   Gender: '性別',
//   Age: '年齡',
//   'Parental status': '家長狀態',
//   'Placement Group': '刊登位置 (群組)',
//   'Added/Excluded': '已新增/已排除',
//   'Placement type': '刊登位置類型',
//   Budget: '預算',
//   'Budget name': '預算名稱',
//   'Campaign type': '廣告活動類型',
//   'Campaign subtype': '廣告活動子類型',
//   'Campaign state': '廣告活動狀態',
//   'Campaign tracking template': '廣告活動追蹤範本',
//   'Campaign final URL suffix': '廣告活動最終到達網址尾碼',
//   'Start date': '開始日期',
//   'End date': '結束日期',
//   'Campaign custom parameter': '廣告活動自訂參數',
//   'Campaign bid strategy': '廣告活動出價策略',
//   'Campaign bid strategy type': '廣告活動出價策略類型',
//   'Ad group state': '廣告群組狀況',
//   'Ad group tracking template': '廣告群組追蹤範本',
//   'Ad group final URL suffix': '廣告群組最終到達網址尾碼',
//   'Ad group custom parameter': '廣告群組自訂參數',
//   'Ad group type': '廣告群組類型',
//   'Ad state': '廣告狀態',
//   'Ad tracking template': '廣告追蹤範本',
//   'Ad type': '廣告類型',
//   Headline: '標題',
//   'Description line 1': '說明行 1',
//   'Description line 2': '說明行 2',
//   'Headline 1': '廣告標題 1',
//   'Headline 2': '廣告標題 2',
//   'Expanded Text Ad Headline 3': '延展型文字廣告標題 3',
//   Description: '說明',
//   'Expanded Text Ad Description 2': '延展型文字廣告說明 2',
//   'Display URL': '顯示網址',
//   'Image ad name': '圖像廣告名稱',
//   'Ad final URL': '廣告最終到達網址',
//   'Ad mobile final URL': '廣告行動最終到達網址',
//   'Ad device preference type': '廣告裝置偏好類型',
//   'Ad custom parameter': '廣告自訂參數',
//   'Ad policies': '廣告政策',
//   'Approval status': '核准狀態',
//   'Search keyword state': '搜尋關鍵字狀況',
//   'Keyword tracking template': '關鍵字追蹤範本',
//   'Keyword final URL suffix': '關鍵字最終到達網址尾碼',
//   'Search keyword max. CPM': '搜尋關鍵字最高千次曝光出價',
//   'Quality score': '品質分數',
//   'Search keyword match type': '搜尋關鍵字比對類型',
//   'Keyword final URL': '關鍵字最終到達網址',
//   'Keyword mobile final URL': '關鍵字行動最終到達網址',
//   'Keyword custom parameter': '關鍵字自訂參數',
//   'Ad group default max. CPC': '廣告群組預設最高單次點擊出價',
//   'Ad group max. CPM': '廣告群組最高千次曝光出價',
//   'Ad group max. CPV': '廣告群組最高單次收視出價',
//   'Ad group target CPA': '廣告群組的目標單次客戶開發出價',
//   'Keyword max CPC': '關鍵字的最高單次點擊出價',
//   'Top of page CPC': '首頁頂端單次點擊出價',
//   'First page CPC': '第一頁單次點擊出價',
//   'First position CPC': '最高排名單次點擊出價',
//   'Audience state': '目標項目狀況',
//   'Topic state': '主題狀況',
//   'Search keyword status': '搜尋關鍵字狀態',
//   'Extension placeholder type': '額外資訊預留位置類型',
//   'Extension status': '額外資訊狀態',
//   'Device preference': '裝置偏好設定',
//   'Conversion action': '轉換動作',
//   'Conversion category': '轉換類別',
//   'Conversion source': '轉換來源',
//   'Conversion adjustment': '轉換調整項',
//   'Days to conversion': '發生轉換所需的天數',
//   'Days to conversion or adjustment': '轉換或調整前的天數',
//   'Country/Territory (Geographic)': '國家/地區/領域 (地理位置)',
//   'Region (Geographic)': '區域 (地理位置)',
//   'Metro area (Geographic)': '都會區 (地理位置)',
//   'City (Geographic)': '城市 (地理位置)',
//   'Country/Territory (User location)': '國家/地區/領域 (使用者所在地)',
//   'Region (User location)': '區域 (使用者所在地)',
//   'Metro area (User location)': '都會區 (使用者所在地)',
//   'City (User location)': '城市 (使用者所在地)',
//   'Location type': '地區類型',
//   Year: '年',
//   Quarter: '季',
//   Month: '月',
//   Week: '週',
//   Day: '天',
//   'Day of week': '星期幾',
//   'Hour of day': '時段',
//   'Ad relevance': '廣告相連性',
//   'Landing page experience': '到達網頁體驗',
//   'Expected clickthrough rate': '預期點閱率',
//   'Est. add. clicks/wk (first position bid)': '預估週增點擊次數 (最高排名出價)',
//   'Est. add. cost/wk (first position bid)': '預估週增費用 (最高排名出價)',
//   all_days: '總計',
//   daily: '每日',
//   default: '預設',
//   'age,gender': '年齡與性別',
//   position: ' ',
//   preview: '預覽',
//   ame: '姓 名',
//   depart: '所 屬 單 位',
//   email: '帳 號',
//   password: '密 碼',
//   OpenAccount: '開 戶',
//   Recharge: '儲 值',
//   Permission: '權 限',
//   'apply BM': '申 請 ADM',
// }

// const t = (n) => fields[n] || n

function ContextProvider(props) {
  const { children } = props
  const [auth, setAuth] = useState({
    authed: false,
  })
  const authValue = useMemo(() => ({ auth, setAuth }), [auth])
  // const { authed, user_id } = auth

  // useEffect(() => {
  //   const generateReport = async () => {
  //     const res = await apiServices.data({
  //       // path: 'research/557031143289127/yearReport',
  //       path: 'research/yearReport/6',
  //       method: 'get',
  //     })
  //     console.log(res)

  //     function transformRecord(record) {
  //       // 複製其他不需要平坦化的屬性
  //       const newRecord = {}
  //       Object.keys(record).forEach((key) => {
  //         if (!['actions', 'cost_per_action_type', 'result'].includes(key)) {
  //           newRecord[key] = record[key]
  //         }
  //       })

  //       // 處理 actions 陣列：產生 "actions:{action_type}" 屬性
  //       if (Array.isArray(record.actions)) {
  //         record.actions.forEach((action) => {
  //           newRecord[`actions:${action.action_type}`] = Number(action.value)
  //         })
  //       }

  //       // 處理 cost_per_action_type 陣列：產生 "cost_per_action_type:{action_type}" 屬性
  //       if (Array.isArray(record.cost_per_action_type)) {
  //         record.cost_per_action_type.forEach((item) => {
  //           newRecord[`cost_per_action_type:${item.action_type}`] = Number(
  //             item.value
  //           )
  //         })
  //       }

  //       // 處理 result 物件：將每個 key 轉為 "result:{key}" 並轉數值
  //       if (record.result && typeof record.result === 'object') {
  //         Object.keys(record.result).forEach((key) => {
  //           newRecord[`result:${key}`] = Number(record.result[key])
  //         })
  //       }

  //       return newRecord
  //     }

  //     const workbook = new ExcelJS.Workbook()
  //     Object.keys(res.setting.yearReport).forEach((key) => {
  //       const data = res.setting.yearReport[key]
  //       if (data.length) {
  //         const ins = data.reduce(
  //           (prev, cur) => ({
  //             ...prev,
  //             [cur.suggestBook.data.ad_id]: cur.suggestBook.ins,
  //           }),
  //           {}
  //         )
  //         const flatted = Object.keys(ins).reduce(
  //           (prev, cur) => {
  //             const temp = ins[cur].map((insight) => transformRecord(insight))
  //             const headers = Object.keys(temp[0]).filter(
  //               (ikey) =>
  //                 !ikey.includes('result') &&
  //                 !ikey.includes('_id') &&
  //                 !ikey.includes('_name') &&
  //                 t(ikey) !== key
  //             )

  //             return {
  //               ...prev,
  //               headers: Array.from(new Set([...prev.headers, ...headers])),
  //               [cur]: temp,
  //             }
  //           },
  //           {
  //             headers: [],
  //           }
  //         )
  //         const worksheet = workbook.addWorksheet(`${key}研究報告`)
  //         const worksheet2 = workbook.addWorksheet(`${key}結案報告`)
  //         data.forEach((d) => {
  //           const ai = d.suggestBook
  //           worksheet.addRow([`${ai.data.campaign_name}的成效總覽`])
  //           worksheet.addRow(flatted.headers.map((header) => t(header)))
  //           if (flatted[ai.data.ad_id])
  //             flatted[ai.data.ad_id].forEach((item) => {
  //               worksheet.addRow(flatted.headers.map((header) => item[header]))
  //             })
  //           worksheet.addRow([])
  //           worksheet.addRow([`${ai.data.campaign_name}的分析報告`])
  //           if (ai.research.research1) worksheet.addRow([ai.research.research1])
  //           if (ai.research.research2) worksheet.addRow([ai.research.research2])
  //           worksheet.getRow(1).height = 35
  //           worksheet.getRow(2).height = 35
  //           flatted[ai.data.ad_id].forEach((item, i) => {
  //             worksheet.getRow(i + 3).height = 35
  //           })
  //           worksheet.getRow(flatted[ai.data.ad_id].length + 4).height = 35
  //           worksheet
  //             .getRow(flatted[ai.data.ad_id].length + 5)
  //             .getCell(1).width = 100
  //           worksheet.getRow(flatted[ai.data.ad_id].length + 5).height = 100
  //           worksheet
  //             .getRow(flatted[ai.data.ad_id].length + 6)
  //             .getCell(1).width = 100
  //           worksheet.getRow(flatted[ai.data.ad_id].length + 6).height = 100

  //           worksheet2.addRow([`${ai.data.campaign_name}的成效總覽`])
  //           worksheet2.addRow([d.report])
  //         })
  //       }
  //     })
  //     const file = await workbook.xlsx.writeBuffer({
  //       base64: true,
  //     })
  //     const data = new Blob([file], {
  //       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //     })
  //     const url = URL.createObjectURL(data)
  //     const link = document.createElement('a')
  //     link.setAttribute('href', url)
  //     link.setAttribute('download', `年度報告.xlsx`)
  //     document.body.appendChild(link)
  //     link.click()
  //   }
  //   generateReport()
  // }, [])

  const checkToken = async () => {
    const { user } = await apiServices.me()
    console.log(user)
    if (user) {
      setAuth({
        authed: true,
        ...user,
      })
    } else {
      setAuth({
        ...auth,
        authed: false,
      })
    }
  }
  useEffect(() => {
    checkToken()
  }, [])

  // const [socket, setSocket] = useState(null)
  // useEffect(() => {
  //   if (!authed) return () => {}
  //   const manager = new Manager(window.location.origin)
  //   const newSocket = manager.socket('/', {
  //     auth: {
  //       auth: user_id,
  //     },
  //   })
  //   setSocket(newSocket)
  //   return () => newSocket.close()
  // }, [setSocket, authed, user_id])
  // const sendMessage = (type, message) => socket.emit(type, message)
  // const socketValue = useMemo(() => ({ socket, sendMessage }), [socket])

  const [containers, setContainers] = useState([])
  const [containerId, setContainerId] = useState('')
  const container = useMemo(() => {
    if (containers && containerId)
      return (
        containers.find(({ container_id }) => container_id === containerId) ||
        {}
      )
    return {}
  }, [containers, containerId])

  const getContainers = async () => {
    const res = await apiServices.data({
      path: 'container/',
      method: 'get',
    })
    console.log('---init containers---')
    console.log(res)
    setContainers(res)
  }

  // useEffect(() => {
  //   if (!auth.authed) return
  //   getContainers()
  // }, [auth.authed])

  const handleAddContainer = async (name, setting) => {
    const res = await apiServices.data({
      path: 'container/',
      method: 'post',
      data: {
        name,
        setting,
      },
    })
    console.log('---add container---')
    console.log(res)
    getContainers()
  }

  const handleEditContainer = async (container_id, name, setting) => {
    const res = await apiServices.data({
      path: `container/${container_id}`,
      method: 'put',
      data: {
        name,
        setting,
      },
    })
    console.log('---edit container---')
    console.log(res)
    getContainers()
  }

  const handleDeleteContainer = async (id) => {
    const res = await apiServices.data({
      path: `container/${id}`,
      method: 'delete',
    })
    console.log('---delete container---')
    console.log(res)
    getContainers()
  }

  const [tags, setTags] = useState([])
  const getTags = async () => {
    const res = await apiServices.data({
      path: `tag/${containerId}`,
      method: 'get',
    })
    console.log('---init tags---')
    console.log(res)
    setTags(res)
  }
  // useEffect(() => {
  //   if (containerId) getTags()
  // }, [containerId])

  const handleAddTag = async (name, setting) => {
    const res = await apiServices.data({
      path: `tag`,
      method: 'post',
      data: {
        name,
        container_id: containerId,
        setting,
      },
    })
    console.log('---add tag---')
    console.log(res)
    getTags()
  }

  const handleEditTag = async (tag_id, name, setting) => {
    const res = await apiServices.data({
      path: `tag/${tag_id}`,
      method: 'put',
      data: {
        name,
        setting,
      },
    })
    console.log('---edit tag---')
    console.log(res)
    getTags()
  }

  const handleDeleteTag = async (id) => {
    const res = await apiServices.data({
      path: `tag/${id}`,
      method: 'delete',
    })
    console.log('---delete tag---')
    console.log(res)
    getTags()
  }

  // const [process, setprocess] = useState({})

  // undo and redo
  // const [history, setHistory] = useState([])
  // const [recoverTarget, setRecoverTarget] = useState(-1)
  // const [cursor, setCursor] = useState(-1)
  // const handleRecover = (target) => setRecoverTarget(target)

  const contextValue = useMemo(
    () => ({
      containers,
      containerId,
      setContainerId,
      handleAddContainer,
      handleEditContainer,
      handleDeleteContainer,
      container,
      tags,
      handleAddTag,
      handleEditTag,
      handleDeleteTag,
    }),
    [containers, containerId, container, tags]
  )

  // useEffect(() => {
  // if (!socket) return
  // if (!drafts) {
  //   sendMessage('draft', { action: 'init' })
  // }
  // if (draftId) {
  //   sendMessage('draft', { action: 'update', data: draft })
  // }
  // }, [socket])

  const [toast, setToast] = useState({ show: false, text: '' })
  const toastValue = useMemo(() => ({ toast, setToast }), [toast])
  return (
    <>
      {/* <NotiContext.Provider value={notification}> */}
      <ToastContext.Provider value={toastValue}>
        <AuthContext.Provider value={authValue}>
          <Context.Provider value={contextValue}>
            {/* <SocketContext.Provider value={socketValue}> */}
            {children}
            {/* </SocketContext.Provider> */}
          </Context.Provider>
        </AuthContext.Provider>
      </ToastContext.Provider>
      {/* </NotiContext.Provider> */}
      <ToastContainer className="p-3" position="bottom-end">
        <Toast
          onClose={() => setToast({ ...toast, show: false })}
          show={toast.show}
          delay={3000}
          autohide
          style={{ width: '100%' }}
        >
          <Toast.Body>{toast.text}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  )
}

ContextProvider.propTypes = {
  children: PropTypes.shape().isRequired,
}

export default ContextProvider

export const Context = createContext(null)
// export const NotiContext = createContext([])
export const SocketContext = createContext({
  socket: null,
  sendMessage: () => {},
})
export const AuthContext = createContext({
  auth: {
    authed: false,
  },
  setAuth: () => {},
})
export const ToastContext = createContext({
  toast: { show: false, text: '' },
  setToast: () => {},
})
